import posthog, { type PostHogConfig } from "posthog-js";
import { removeQueryStrings } from "../support/browser-hacks";

const publicKey = "phc_CYeeEQAYy3aBXVNKkGixozIAYtyiNhxde4q30cnK533";

export function initializePosthog() {
    const options: Partial<PostHogConfig> = { api_host: "https://us.i.posthog.com", autocapture: false };

    // Bootstrap PostHog IDs passed in the URL, if any.
    const url = new URL(window.location.href);
    const distinctID = url.searchParams.get("phid");
    const sessionID = url.searchParams.get("phsid");
    if (distinctID !== null && sessionID !== null) {
        options["bootstrap"] = { distinctID, sessionID };
        removeQueryStrings("phid", "phsid");
    }

    posthog.init(publicKey, options);

    // Set posthog on window for debugging
    try {
        (window as any).posthog = posthog;
    } catch {
        // eslint-disable-next-line no-console
        console.error("Failed to set posthog on window");
    }
}

type Trait = "email" | "name" | "created_at";

// https://posthog.com/docs/product-analytics/identify
export function identifyPosthogUser(userId: string, traits?: Record<Trait, any>) {
    posthog.identify(userId, traits);

    // Read Posthog distinct_id for users coming from marketing site
    const url = new URL(window.location.href);
    const distinctId = url.searchParams.get("phid");
    if (distinctId !== null) {
        posthog.alias(distinctId, userId);
        removeQueryStrings("phid");
    }
}

// https://posthog.com/docs/product-analytics/capture-events
export function capturePosthogEvent(eventName: string, properties?: Record<string, any>) {
    posthog.capture(eventName, properties);
}
